import {compact} from 'lodash';

import {MeetingRoomModel} from '../../models/api/meetingRoomModel';

export function buildCompleteMeetingRoomName(room: MeetingRoomModel) {
  const roomTokens = compact([room.buildingName, room.floorName, room.roomName]);
  return roomTokens.join('-');
}
